const SERVICES = [
  {
    id: "field_os",
    name: "Field OS",
    icon: "workspaces",
    path: "/field-os",
    description: "Manage your field teams, activities and operations.",
  },
  {
    id: "voice",
    name: "Voice",
    icon: "dialer_sip",
    path: "/voice-os",
    description: "Manage business calls, call centers and call analytics.",
  },
];

export default SERVICES;
